import React from 'react'
import { Box, Button, Dialog, DialogContent, TextField, Typography, useTheme } from '@mui/material';
import * as yup from "yup";
import { Formik } from "formik";
import { tokens } from '../theme';

function BrandProdcutDialog({ open, handleClose, handleSubmit, brandProduct, adType, brandId, adId }) {
    const theme = useTheme();
    const colors = tokens(theme.palette.colors);

    var initialValues = {
        brand_id: brandProduct ? brandProduct.brand_id : brandId,
        ad_id: brandProduct ? (adType === "independentCoupon" ? brandProduct.independent_coupon_id : brandProduct.ad_id) : adId,
        name: brandProduct?.name ? brandProduct.name : "",
        description: brandProduct?.description ? brandProduct.description : "",
        price: brandProduct?.price ? brandProduct.price : "",
        discounted_price: brandProduct?.discounted_price ? brandProduct.discounted_price : "",
        link: brandProduct?.link ? brandProduct.link : "",
        image1: null,
        image2: null,
        image3: null,
        image_link_1: brandProduct?.image_link_1 ? brandProduct.image_link_1 : "",
        image_link_2: brandProduct?.image_link_2 ? brandProduct.image_link_2 : "",
        image_link_3: brandProduct?.image_link_3 ? brandProduct.image_link_3 : "",
    }

    var shapeObject = {
        name: yup.string().required("zorunlu"),
        description: yup.string().required("zorunlu"),
        price: yup.number().required("zorunlu"),
        discounted_price: yup.number().required("zorunlu"),
        link: yup.string().required("zorunlu"),
        brand_id: yup.number().required("zorunlu"),
        ad_id: yup.number().required("zorunlu"),
        image1: yup.mixed().nullable().when('image_link_1', {
            is: (image_link_1) => !image_link_1 || image_link_1 === "",
            then: () => yup.mixed().required("zorunlu")
        }),
        image2: yup.mixed().nullable().when('image_link_2', {
            is: (image_link_2) => !image_link_2 || image_link_2 === "",
            then: () => yup.mixed().required("zorunlu")
        }),
        image3: yup.mixed().nullable().when('image_link_3', {
            is: (image_link_3) => !image_link_3 || image_link_3 === "",
            then: () => yup.mixed().required("zorunlu")
        }),
        image_link_1: yup.string(),
        image_link_2: yup.string(),
        image_link_3: yup.string(),
    }

    const schema = yup.object().shape(shapeObject);

    return (
        <Dialog
            sx={{ margin: "0 auto" }}
            open={open}
            fullWidth
            maxWidth="md"
            onClose={handleClose}
        >
            <Box m="20px" mb="0" textAlign="center">
                <Typography variant='h3'>
                    {brandProduct ? brandProduct.name : "Yeni Ürün Ekle"}
                </Typography>
            </Box>
            <DialogContent>
                <Box>
                    <Formik
                        onSubmit={(values) => {
                            let newValues = { ...values };
                            if (adType === "independentCoupon") {
                                newValues.independent_coupon_id = newValues.ad_id;
                                delete newValues.ad_id;
                            }
                            handleSubmit(newValues);
                        }}
                        initialValues={initialValues}
                        validationSchema={schema}
                    >
                        {({ values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue }) => (
                            <form onSubmit={handleSubmit}>
                                <Box display="grid" gap="15px" gridTemplateColumns="repeat(3, minmax(0, 1fr))" mx="75px" my="25px">
                                    <Box textAlign="center" sx={{ gridColumn: "span 1" }}>
                                        <Typography variant="h6">Görsel (830 x 710)</Typography>
                                        <Button variant="contained" component="label" style={{ textAlign: "center", background: colors.grey[700], height: "150px", width: "150px" }}>
                                            {(values.image1 || (values.image_link_1 && values.image_link_1 !== "")) && <img alt='image1' style={{ maxWidth: "140px", maxHeight: "140px", minWidth: "140px", minHeight: "140px", objectFit: "contain" }} src={values.image1 ? URL.createObjectURL(values.image1) : values.image_link_1} />}
                                            <input id="image1" name="image1" type="file" accept=".png, .jpeg, .jpg" onChange={(event) => { setFieldValue("image1", event.target.files[0]); }} hidden />
                                        </Button>
                                    </Box>
                                    <Box textAlign="center" sx={{ gridColumn: "span 1" }}>
                                        <Typography variant="h6">Görsel (780 x 1030)</Typography>
                                        <Button variant="contained" component="label" style={{ textAlign: "center", background: colors.grey[700], height: "150px", width: "150px" }}>
                                            {(values.image2 || (values.image_link_2 && values.image_link_2 !== "")) && <img alt='image2' style={{ maxWidth: "140px", maxHeight: "140px", minWidth: "140px", minHeight: "140px", objectFit: "contain" }} src={values.image2 ? URL.createObjectURL(values.image2) : values.image_link_2} />}
                                            <input id="image2" name="image2" type="file" accept=".png, .jpeg, .jpg" onChange={(event) => { setFieldValue("image2", event.target.files[0]); }} hidden />
                                        </Button>
                                    </Box>
                                    <Box textAlign="center" sx={{ gridColumn: "span 1" }}>
                                        <Typography variant="h6">Görsel (1200 x 620)</Typography>
                                        <Button variant="contained" component="label" style={{ textAlign: "center", background: colors.grey[700], height: "150px", width: "150px" }}>
                                            {(values.image3 || (values.image_link_3 && values.image_link_3 !== "")) && <img alt='image3' style={{ maxWidth: "140px", maxHeight: "140px", minWidth: "140px", minHeight: "140px", objectFit: "contain" }} src={values.image3 ? URL.createObjectURL(values.image3) : values.image_link_3} />}
                                            <input id="image3" name="image3" type="file" accept=".png, .jpeg, .jpg" onChange={(event) => { setFieldValue("image3", event.target.files[0]); }} hidden />
                                        </Button>
                                    </Box>
                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="text"
                                        label="Ürün Başlığı"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.name}
                                        name="name"
                                        error={!!touched.name && !!errors.name}
                                        helperText={touched.name && errors.name}
                                        sx={{ gridColumn: "span 3", mt: "10px" }}
                                    />
                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="text"
                                        label="Ürün Açıklaması"
                                        multiline
                                        rows={6}
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.description}
                                        name="description"
                                        error={!!touched.description && !!errors.description}
                                        helperText={touched.description && errors.description}
                                        sx={{ gridColumn: "span 3" }}
                                    />
                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="text"
                                        label="Ürün Linki"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.link}
                                        name="link"
                                        error={!!touched.link && !!errors.link}
                                        helperText={touched.link && errors.link}
                                        sx={{ gridColumn: "span 3", mt: "18px" }}
                                    />
                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="number"
                                        label="İndirimsiz Fiyat"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.price}
                                        name="price"
                                        error={!!touched.price && !!errors.price}
                                        helperText={touched.price && errors.price}
                                        sx={{ gridColumn: "span 1", mt: "18px" }}
                                    />
                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="number"
                                        label="İndirimli Fiyat"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.discounted_price}
                                        name="discounted_price"
                                        error={!!touched.discounted_price && !!errors.discounted_price}
                                        helperText={touched.discounted_price && errors.discounted_price}
                                        sx={{ gridColumn: "span 1", mt: "18px" }}
                                    />
                                </Box>
                                <Box display="flex" justifyContent="center" m="20px 20px 0px 20px">
                                    <Button type="submit" color="secondary" variant="contained">
                                        <Typography variant='h5'>Kaydet</Typography>
                                    </Button>
                                </Box>
                            </form>
                        )}
                    </Formik>
                </Box>
            </DialogContent>
        </Dialog>
    )
}

export default BrandProdcutDialog